import { defineFeatures } from "../define-provider-capability";

/** The storage-write gate used by the app, without server-only GCP features. */
export const gcpMobileFeatures = defineFeatures({
  // Write/delete/mint signed write URLs in GCP/Firebase Storage.
  storageWrite: {
    scope: "runtime",
    environments: {
      local: { mode: "managed" },
      preview: {
        mode: "not-applicable",
        note: "Preview must not write to shared GCP resources.",
      },
      production: { mode: "managed" },
    },
  },
});
